import { graphql } from "@/gql";

export const regenerateRelocationOgImageMutation = graphql(`
  mutation ReGenerateRelocationOgImage(
    $id: ID!
    $prompt: String
    $model: ImageGenerationModel
  ) {
    regenerateOGImage(id: $id, prompt: $prompt, model: $model)
  }
`);
